module.exports = __webpack_public_path__ + "static/media/storeBanner2.0cc52642.png";